import type { AutomationId } from "../types";
import type { FluxmedDefaultTemplateCategory } from "../../messageTemplates/utils/messageTemplateUiUtils";

/** Automações obrigatórias do sistema — não podem ser desabilitadas pelo usuário. */
export const SYSTEM_DEFAULT_AUTOMATION_IDS = [
  "confirmation",
  "cancellation",
  "payment",
] as const satisfies readonly AutomationId[];

export type SystemDefaultAutomationId =
  (typeof SYSTEM_DEFAULT_AUTOMATION_IDS)[number];

/** Categoria de modelos padrão relacionada a cada automação do sistema. */
export const SYSTEM_DEFAULT_AUTOMATION_TEMPLATE_CATEGORY: Record<
  SystemDefaultAutomationId,
  FluxmedDefaultTemplateCategory
> = {
  confirmation: "agendamento",
  cancellation: "cancelamento",
  payment: "pagamento",
};

export function getDefaultTemplateCategoryForAutomation(
  automationId: SystemDefaultAutomationId,
): FluxmedDefaultTemplateCategory {
  return SYSTEM_DEFAULT_AUTOMATION_TEMPLATE_CATEGORY[automationId];
}

export function isSystemDefaultAutomation(
  automationId: AutomationId,
): automationId is SystemDefaultAutomationId {
  return (SYSTEM_DEFAULT_AUTOMATION_IDS as readonly AutomationId[]).includes(
    automationId,
  );
}

/** Garante que automações padrão do sistema apareçam primeiro no painel. */
export function compareAutomationDisplayOrder(
  automationIdA: AutomationId,
  automationIdB: AutomationId,
): number {
  const aIsSystemDefault = isSystemDefaultAutomation(automationIdA);
  const bIsSystemDefault = isSystemDefaultAutomation(automationIdB);

  if (aIsSystemDefault && !bIsSystemDefault) return -1;
  if (!aIsSystemDefault && bIsSystemDefault) return 1;

  if (aIsSystemDefault && bIsSystemDefault) {
    return (
      SYSTEM_DEFAULT_AUTOMATION_IDS.indexOf(automationIdA) -
      SYSTEM_DEFAULT_AUTOMATION_IDS.indexOf(automationIdB)
    );
  }

  return 0;
}

export const AUTOMATION_DISPLAY_TITLES: Record<AutomationId, string> = {
  confirmation: "Confirmação",
  cancellation: "Cancelamento",
  payment: "Pagamento",
  triage: "Triagem",
  preConsultation: "Pré-Consulta",
  postConsultation: "Pós-Consulta",
  birthday: "Aniversariantes",
};

export const AUTOMATION_TRIGGER_MOMENTS: Partial<Record<AutomationId, string>> = {
  triage: "Quando um paciente realizar um agendamento pela agenda externa.",
  preConsultation: "Quando a consulta for confirmada.",
  postConsultation: "Quando o atendimento do paciente for finalizado.",
  birthday:
    "Disparo manual pelo dashboard profissional para aniversariantes do dia.",
};
